import React from 'react';
import { useListReportsByEnterpriseQuery } from '@/graphql/generated';

export const useListReportsByEnterprise = (
  enterpriseId: string | undefined,
  refreshKey?: number,
) => {
  const { data, loading, refetch } = useListReportsByEnterpriseQuery({
    variables: { enterpriseId: enterpriseId ? enterpriseId : '' },
    skip: !enterpriseId,
  });

  // Refetch when refreshKey changes
  React.useEffect(() => {
    if (refreshKey && refreshKey > 0) {
      refetch();
    }
  }, [refreshKey, refetch]);

  return {
    loading,
    reports: data?.reports,
  };
};
